import { PageHeader } from '~/components/PageHeader/PageHeader';
import { ErrorBoundary } from '~/components/ErrorBoundary';
import { useUserAccount } from '~/contexts/UserAccount/UserAccountContext';
import { SavedDesigns } from './SavedDesigns/SavedDesigns';

export function Designs() {
    const { account } = useUserAccount();

    return (
        <>
            <PageHeader>{account.personal ? 'My Designs' : 'Team Designs'}</PageHeader>
            <ErrorBoundary errorMessage="An error occurred while retrieving the designs">
                <SavedDesigns />
            </ErrorBoundary>
        </>
    );
}
